import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
    primary:   { main: "#1a6b3c", light: "#2d9c5a", dark: "#0f4525", contrastText: "#fff" },
    secondary: { main: "#e85d04", light: "#f48c06", dark: "#c44b00", contrastText: "#fff" },
    background:{ default: "#fdf6ec", paper: "#ffffff" },
    text:      { primary: "#0d1f15", secondary: "#4a5568" },
    success:   { main: "#2d9c5a" },
    info:      { main: "#0369a1" },
    warning:   { main: "#fbbf24" },
  },
  typography: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    h1: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 900, letterSpacing: "-2px" },
    h2: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 900, letterSpacing: "-1.5px" },
    h3: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 },
    h4: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 },
    h5: { fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 },
    h6: { fontWeight: 700 },
    overline: { fontFamily: "'Space Mono', monospace", fontWeight: 700, letterSpacing: "3px" },
    caption:  { fontFamily: "'Space Mono', monospace" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, fontSize: "15px", borderRadius: "8px" },
        contained: { boxShadow: "none", "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,0.18)" } },
      },
    },
    MuiCard: { styleOverrides: { root: { boxShadow: "none", border: "1px solid rgba(0,0,0,0.07)" } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
  },
});

export default theme;